<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button @click="createAccount()" class="bg_l_green" v-has-permission="'CreateGroupAccount'">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewGroupAccount") }}
            </vs-button>
          </div>
        </div>

        <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          @finish="onfinish"
          @close="closeModifyPopup"
        >
        </modify-popup>

        <modify-child-popup
          :show="ModifyPopupChild"
          :model="modalModelChild"
          :parentType="parentType"
          :parentCode="parentCode"
          @finishGeneral="onfinish"
          @close="closeModifyPopup"
        >
        </modify-child-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('AccountGroupTitle'), sort: 'AccountGroupTitle' },
                { title: $t('AccountCode'), sort: 'AccountCode' },
                { title: $t('Description'), sort: 'Description' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.title }}
                </td>
                <td style="direction: ltr">
                  {{ row.code }}
                </td>
                <td>
                  {{ row.description ? row.description : "-" }}
                </td>
                <td>
                  <vs-button
                    flat
                    color="primary"
                    tooltip="hello"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    @click.prevent="addChild(row.id , row.code)"
                    class="d-inline"
                    v-has-permission="'CreateGeneralAccount'"
                  >
                    {{ $t("CreateNewGeneralAccount") }}</vs-button
                  >
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./CreatePopup.vue";
import ModifyChildPopup from "./CreateGeneralAccountPopup.vue";
export default {
  components: {
    ModifyPopup,
    ModifyChildPopup,
    DataGrid,
  },
  data() {
    return {
      ModifyPopup: false,
      ModifyPopupChild: false,
      modalModel: {},
      modalModelChild: {},
      parentType: 0,
      parentCode: 0,
      itemList: [],
      gridDataSource: {
        type: "app",
        service: "Credits/api/GroupAccountsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeAccount: "groupAccount/remove",
      getAccount: "groupAccount/fetch",
    }),
    ////Open Modal In Create Mode
    createAccount() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    /////AddChild
    addChild(id , code) {
      this.parentType = id;
      this.parentCode = code;
      // this.getData();
      this.modalModelChild = {};
      this.ModifyPopupChild = true;
    },
    // getData(){
    //     this.getAccount().then((r) => {
    //         this.parentType=r
    //       });
    // },
    //Open Modal In Edit Mode
    editAccount(model) {
      this.modalModel = { id: model.id, name: model.name };
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteAccount(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeAccount(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
      this.ModifyPopupChild = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    onfinishGeneral() {
      this.closeModifyPopup();
    },
  },
};
</script>
